/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModalRedefinirSenhaAliases {
  BUTTON_CONFIRMAR = 'button-confirmar',
  FIELD_0 = 'field-0',
  FIELD_CONFIRMAR = 'field-confirmar',
  FIELD_NOVA_SENHA = 'field-nova-senha',
  FORM = 'form',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  LAYOUT_0 = 'layout-0',
  PANEL_0 = 'panel-0',
  PANEL_REDEFINIR_SENHA = 'panel-redefinir-senha',
}
export { ModalRedefinirSenhaAliases };
